export default "__VITE_ASSET__JKwtpY$9__"